import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';

@Component({
  selector: 'app-beeztel-service-access-url-vars',
  templateUrl: './beeztel-service-access-url-vars.component.html',
  styleUrls: ['./beeztel-service-access-url-vars.component.scss']
})
export class BeeztelServiceAccessUrlVarsComponent extends ModalExtended implements OnInit {

    data: Object;

    onExit(): void {
        this.close();
    }

    constructor() {
        super();
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/beeztel/beeztel-service-access-url-vars/beeztel-service-access-url-vars.component.ts